const e=(t,n)=>!!n&&(t===n||e(t,n.parentElement));export{e as isNodeOrChild};
